import axios from 'axios';

export const deleteUserSessions = async (authtoken, email) => {
  const axiosInstance = axios.create({
    withCredentials: true
  });
  const config = {
    headers: {
      authtoken
    }
  };
  return await axiosInstance.post(
    process.env.REACT_APP_API + '/del/user/sessions',
    { email },
    config
  );
};
export const createBackupOfDB = async (authtoken) => {
  // console.log('api call createBackupOfDB... ');
  const axiosInstance = axios.create({
    withCredentials: true
  });
  const config = {
    headers: {
      authtoken
    }
  };
  return await axiosInstance.post(
    process.env.REACT_APP_API + '/create/backup/db',
    {},
    config
  );
};

export const fetchChapterDataApi = async (authtoken, user) => {
  const axiosInstance = axios.create({
    withCredentials: true
  });
  const config = {
    headers: {
      authtoken
    }
  };
  return await axiosInstance.post(
    process.env.REACT_APP_API + '/get/chapters',
    { 
      authtoken,
      user 
    },
    config
  );
};

export const fetchAvatarProviderApi = async (authtoken, user) => {
  const axiosInstance = axios.create({
    withCredentials: true,
  });

  const organizationId =
    typeof user.organization === 'string'
      ? user.organization
      : user.organization.name;

  const url = process.env.REACT_APP_API + '/get/avatar/provider';
  const payload = { organizationId };
  const config = { headers: { authtoken } };

  console.log("[CLIENT] AvatarProvider → Request:", {
    url,
    payload,
    headers: config.headers,
  });

  try {
    const res = await axiosInstance.post(url, payload, config);

    console.log("[CLIENT] AvatarProvider → Response:", res.data);

    if (res.data?.error?.isError) {
      console.log("[CLIENT] AvatarProvider → Error Flag:", res.data.error);
      throw new Error(res.data.error.message || 'Failed to fetch avatar provider');
    }

    return res.data.data;  // { organizationId, provider }

  } catch (err) {
    console.error("[CLIENT] AvatarProvider → Request FAILED:", err);
    throw err;
  }
};

// Dev-only: fetch the assembled system prompt for a case study + avatar so the
// dev prompt-override editor can show the current prompt before an override launch.
export const fetchPromptPreviewApi = async (authtoken, { caseStudy, personality, version }) => {
  const axiosInstance = axios.create({
    withCredentials: true,
  });

  const url = process.env.REACT_APP_API + '/get/prompt/preview';
  const config = {
    headers: { authtoken },
    params: {
      case_study: caseStudy,
      personality,
      version: version || '0.1',
      // Dev-only tool: target the dev AI service (override with env if ever needed).
      env: process.env.REACT_APP_PROMPT_OVERRIDE_AI_ENV || 'dev',
    },
  };

  try {
    const res = await axiosInstance.get(url, config);
    if (res.data?.error?.isError && `${res.data.error.isError}` !== '0') {
      throw new Error(res.data.error.message || 'Failed to fetch prompt preview');
    }
    return res.data.data; // { case_study, personality, version, system_message }
  } catch (err) {
    console.error('[CLIENT] PromptPreview → Request FAILED:', err);
    throw err;
  }
};

export const fetchLearningPathLevelApi = async (authtoken, user) => {
  const axiosInstance = axios.create({
    withCredentials: true,
  });

  const url = process.env.REACT_APP_API + '/learning-path/user/level';

  const payload = {
    request: {
      email: user.email,     // 👈 controller supports { userId } or { email }
    },
  };

  const config = { headers: { authtoken } };

  console.log("[CLIENT] LearningPath → Request:", {
    url,
    payload,
    headers: config.headers,
  });

  try {
    const res = await axiosInstance.post(url, payload, config);

    console.log("[CLIENT] LearningPath → Response:", res.data);

    if (res.data?.error?.isError === "1") {
      console.log("[CLIENT] LearningPath → Error Flag:", res.data.error);
      throw new Error(res.data.error.message || 'Failed to fetch learning path level');
    }

    // learningPath.controller getUserLearningPathLevel returns:
    // {
    //   data: {
    //     userId, email, name, learningPathLevel
    //   },
    //   error: {...}
    // }
    return res.data.data;

  } catch (err) {
    console.error("[CLIENT] LearningPath → Request FAILED:", err);
    throw err;
  }
};

export const createCustomChapterGroupApi = async (authtoken, cg) => {
  // console.log('---- createCustomChapterGroupApi');
  const axiosInstance = axios.create({
    withCredentials: true
  });
  const config = {
    headers: {
      authtoken
    }
  };
  return await axiosInstance.post(
    process.env.REACT_APP_API + '/update/chapter/group',
    { cg },
    config
  );
}

export const getChapterGroupApi = async (authtoken, name) => {
  // console.log('---- getChapterGroupApi', name);
  const axiosInstance = axios.create({
    withCredentials: true
  });
  const config = {
    headers: {
      authtoken
    }
  };
  return await axiosInstance.post(
    process.env.REACT_APP_API + '/get/chapter/group',
    { name },
    // config
  );
}
